import { render, staticRenderFns } from "./lopsandrlops.vue?vue&type=template&id=c79238cc&scoped=true"
import script from "./lopsandrlops.vue?vue&type=script&lang=js"
export * from "./lopsandrlops.vue?vue&type=script&lang=js"
import style0 from "./lopsandrlops.vue?vue&type=style&index=0&id=c79238cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79238cc",
  null
  
)

export default component.exports